//
//
//
//
//
//
//

import { mapState } from 'vuex';
import CallOut from './components/CallOut.vue';
import ResultsDisplay from './components/ResultsDisplay.vue';

export default {
  components: {
    CallOut,
    ResultsDisplay
  },  
  data() {
    return {
      errorMessageFromDataset: '',
      calloutTitleFromDataset: '',
      calloutDescriptionFromDataset: ''
    };
  },
  computed: {
    ...mapState(['submittedResults', 'showResults', 'isInitialLoad']),  
    calloutTitle() {
      return this.calloutTitleFromDataset || 'Find Your Property Asset Management Officer';
    },
    calloutDescription() {
      return this.calloutDescriptionFromDataset || 'Please select a city or property...';
    },
    errorMessage() {
        return this.errorMessageFromDataset || 'There was an error retrieving the data. Please try again later.';
    }
  },
  mounted() {
    this.errorMessageFromDataset = this.$root.errorMessage || '';
    this.calloutTitleFromDataset = this.$root.title || '';
    this.calloutDescriptionFromDataset = this.$root.description || '';
  }
};
